/**
 * @desc 无数据页面展示的内容
 */
import React from 'react';
export default function NoDataContent(props) {
    const { className, style } = props;
    return (<div className={`flex__column-center ${className}`} style={style}>
        <img src="https://assets.souche.com/assets/sccimg/common/common_background_nocar.png" alt="暂无预览内容" width="96" height="96"/>
        <div>暂无数据</div>
    </div>);
}
